export const SET_AGENT_SESSION_TOKEN = 'SET_AGENT_SESSION_TOKEN';

export function setAgentSessionToken(agentSessionToken) {
  return { type: SET_AGENT_SESSION_TOKEN, agentSessionToken };
}
